export default __webpack_public_path__ + "static/media/kitchen4-afterD-768w.981592f5.png";